import React from 'react'
import { Badge, ListGroup } from 'react-bootstrap'

export default function List() {


    const doctors = [
        { name: 'Peripheral Blood Smear', count: 150 },
        { name: 'Urine Microscopy', count: 95 },
        { name: 'Semen Analysis', count: 90 },
        { name: 'Sputum Microscopy', count: 80 },
        { name: 'Bone Marrow Aspiration and Biopsy', count: 65 },
        { name: 'Fine Needle Aspiration (FNA)', count: 60 },
        { name: 'Vaginal Wet Mount', count: 50 },
        { name: 'Ziehl-Neelsen Stain (Acid-Fast Stain)', count: 45 },
        { name: 'Synovial Fluid Analysis', count: 40 },
        { name: 'Examination of Cerebral Microvasculature', count: 39 },
    ];

    return (
        <ListGroup as="ul">
            {doctors.map((doctor, index) => (
                <ListGroup.Item
                    key={index}
                    as="li"
                    className="d-flex justify-content-between align-items-start"
                >
                    <div className="ms-2 me-auto">
                        <div className="fw-bold">{doctor.name}</div>
                    </div>
                    <Badge bg="primary" pill>
                        {doctor.count}
                    </Badge>
                </ListGroup.Item>
            ))}
        </ListGroup>
    )
}
